import { render, staticRenderFns } from "./DefBody.vue?vue&type=template&id=f6aae534&scoped=true&"
import script from "./DefBody.vue?vue&type=script&lang=js&"
export * from "./DefBody.vue?vue&type=script&lang=js&"
import style0 from "./DefBody.vue?vue&type=style&index=0&id=f6aae534&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6aae534",
  null
  
)

export default component.exports